module.exports = __webpack_public_path__ + "img/selected2-min.68a89920.png";